import { render, staticRenderFns } from "./newgeonotification.vue?vue&type=template&id=12122c8e&scoped=true"
import script from "./newgeonotification.vue?vue&type=script&lang=js"
export * from "./newgeonotification.vue?vue&type=script&lang=js"
import style0 from "./newgeonotification.vue?vue&type=style&index=0&id=12122c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12122c8e",
  null
  
)

export default component.exports